export default __webpack_public_path__ + "static/media/Completed_C.6a2c3e2c.svg";